import { render, staticRenderFns } from "./LicenseBanner.vue?vue&type=template&id=f1319fa8&scoped=true&"
import script from "./LicenseBanner.vue?vue&type=script&lang=ts&"
export * from "./LicenseBanner.vue?vue&type=script&lang=ts&"
import style0 from "./LicenseBanner.vue?vue&type=style&index=0&id=f1319fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1319fa8",
  null
  
)

export default component.exports